<div class="px-6 pb-6">
  <h1 class="text-center text-2xl font-semibold font-mulish mb-4">Sign In Error</h1>
  <hr>
  <p class="text-gray-600 mt-4 md:mt-6 text-xl font-mulish">There was an error signing in.</p>
  <ul>
    <li>
      <p class="text-gray-600 mt-4 md:mt-6 text-lg font-mulish">Please check the Date and Time on your computer or phone to make sure they are accurate.</p>
    </li>
    <li>
      <p class="text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        If you continue to have trouble signing in, please
        <a class="cursor-pointer" href="https://support.frontstream.com/hc/en-us/requests/new">submit a request</a>
        to our Support team.
      </p>
    </li>
  </ul>
</div>
